import authHeader from "../../../../authentication/authservices/auth-header";
import apiClient from "../../../../http-common";
// import { apiClient } from "../../../http-common";

//Complaints
//Complaint List
export const getComplaints = (searchkey) => {
  return apiClient.get(`/masters/complaints/search/${searchkey}`, {
    headers: authHeader(),
  });
};

//

export const postOpdEMR = async (obj) => {
  return await apiClient.post(`/opd/patientemr/saveEmr`, obj, {
    headers: authHeader(),
  });
};

export const getOpdEMR = async (obj) => {
  return await apiClient.post(
    `/opd/patientemr/getPatientAssessmentDetails`,
    obj,
    {
      headers: authHeader(),
    },
  );
};

// /masters/employees/getDoctorList/9/oncology

export const getDoctor = (unitId, department) => {
  return apiClient.get(
    `/masters/employees/getDoctorList/${unitId}/${department}`,
    {
      headers: authHeader(),
    },
  );
};

export const getImage = (name, type) => {
  if (type === "pdf") {
    return apiClient.get(`/file/${name}`, {
      headers: authHeader(),
      responseType: "blob",
    });
  } else {
    return apiClient.get(`/file/${name}`, {
      headers: authHeader(),
      responseType: "arraybuffer",
    });
  }
};

export const getPatientHistory = (PatientId, Department, unitId) => {
  return apiClient.get(
    `/opd/patientemr/getPatientHistoryDepartmentWise/${PatientId}/${Department}/${unitId}`,
    {
      headers: authHeader(),
    },
  );
};
// /patientemr/getPatientHistoryDepartmentWise/5822/Oncology

